import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import MasterAssetService from "services/Setup/Master/masterAssetService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  CountryIdList: [{ code: "", name: "" }],
  OriginationIdList: [{ code: "", name: "" }],
  MasterAssetAttributeList: [{ code: "", name: "" }],
  DocumentTypeList: [{ code: "", name: "" }],
  DocumentStatusList: [{ code: "", name: "" }],
  DocumentStatusList: [{ code: "", name: "" }],
  IsNewAssetList: [{ id: "", name: "" }],
  IsUsedAssetList: [{ id: "", name: "" }],
  IsNoRequiredList: [{ id: "", name: "" }],
};

export const getCountryIdList = createAsyncThunk(
  "masterAsset/getCountryId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterAssetService.getCountryId();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getOriginationIdList = createAsyncThunk(
  "masterAsset/getOriginationId",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterAssetService.getOriginationId();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getMasterAssetAttributeList = createAsyncThunk(
  "masterAsset/getMasterAssetAttribute",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterAssetService.getMasterAssetAttribute();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getIsNewAssetList = createAsyncThunk(
  "masterAsset/getIsNewAsset",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterAssetService.getIsNewAsset();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getIsUsedAssetList = createAsyncThunk(
  "masterAsset/getIsUsedAsset",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterAssetService.getIsUsedAsset();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getDocumentTypeList = createAsyncThunk(
  "masterAsset/getDocumentType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterAssetService.getDocumentType();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getDocumentStatusList = createAsyncThunk(
  "masterAsset/getDocumentStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterAssetService.getDocumentStatus();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getCustomerTypeList = createAsyncThunk(
  "masterAsset/getCustomerType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterAssetService.getCustomerType();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getIsNoRequiredList = createAsyncThunk(
  "masterAsset/getIsNoRequired",
  async (data, { rejectWithValue }) => {
    try {
      const response = await MasterAssetService.getIsNoRequired();
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const masterAsset = createSlice({
  name: "masterAsset",
  initialState,
  reducer: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get list country id
      .addCase(getCountryIdList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCountryIdList.fulfilled, (state, action) => {
        state.loading = false;
        state.CountryIdList = action.payload;
      })
      .addCase(getCountryIdList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list origination id
      .addCase(getOriginationIdList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getOriginationIdList.fulfilled, (state, action) => {
        state.loading = false;
        state.OriginationIdList = action.payload;
      })
      .addCase(getOriginationIdList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list master asset attribute
      .addCase(getMasterAssetAttributeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getMasterAssetAttributeList.fulfilled, (state, action) => {
        state.loading = false;
        state.MasterAssetAttributeList = action.payload;
      })
      .addCase(getMasterAssetAttributeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list IsNewAsset
      .addCase(getIsNewAssetList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getIsNewAssetList.fulfilled, (state, action) => {
        state.loading = false;
        state.IsNewAssetList = action.payload;
      })
      .addCase(getIsNewAssetList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list IsUsedAsset
      .addCase(getIsUsedAssetList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getIsUsedAssetList.fulfilled, (state, action) => {
        state.loading = false;
        state.IsUsedAssetList = action.payload;
      })
      .addCase(getIsUsedAssetList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list DocumentType
      .addCase(getDocumentTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getDocumentTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.DocumentTypeList = action.payload;
      })
      .addCase(getDocumentTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list DocumentType
      .addCase(getDocumentStatusList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getDocumentStatusList.fulfilled, (state, action) => {
        state.loading = false;
        state.DocumentStatusList = action.payload;
      })
      .addCase(getDocumentStatusList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list CustomerType
      .addCase(getCustomerTypeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCustomerTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.CustomerTypeList = action.payload;
      })
      .addCase(getCustomerTypeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //get list IsNoRequired
      .addCase(getIsNoRequiredList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getIsNoRequiredList.fulfilled, (state, action) => {
        state.loading = false;
        state.IsNoRequiredList = action.payload;
      })
      .addCase(getIsNoRequiredList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  masterAsset.actions;

export default masterAsset.reducer;
